import React from "react";
import BoardComponent from "../../components/support/BoardComponent";

const NoticePage = () => {
  return <BoardComponent />;
};

export default NoticePage;
